export enum USER_DIRECTORY_BACK_OFFICE {
    /**
     * @value Add user field
     * @description Label of the primary action in the User Directory admin Template tab empty state, shown when the template has no user field left. Opens the create-field dialog.
     */
    ADD_USER_FIELD = 'USER_DIRECTORY_ADMIN.ADD_USER_FIELD',
    /**
     * @value Users can edit their own profile
     */
    ALLOW_PROFILE_UPDATE = 'ADMIN_MODULE_SETTINGS_USER_CAN_EDIT_PROFILE',
    /**
     * @value The main user directory cannot be deleted.
     */
    CANNOT_DELETE_MAIN_DIRECTORY = 'USER_DIRECTORY.CANNOT_DELETE_MAIN_DIRECTORY',
    /**
     * @value Component
     */
    COMPONENT = 'USER_DIRECTORY_ADMIN.COMPONENT',
    /**
     * @value Configure a message shown at the top of the list.
     */
    CUSTOM_MESSAGE_DESCRIPTION = 'USER_DIRECTORY_ADMIN.CUSTOM_MESSAGE_DESCRIPTION',
    /**
     * @value Custom Pattern
     */
    CUSTOM_PATTERN = 'USER_DIRECTORY_ADMIN.CUSTOM_PATTERN',
    /**
     * @value For more information about custom pattern, refer to the documentation
     */
    CUSTOM_PATTERN_HELPER = 'USER_DIRECTORY_ADMIN.CUSTOM_PATTERN_HELPER',
    /**
     * @value Define custom pattern
     * @description Radio button label for the custom validation pattern option in the template field form
     */
    DEFINE_CUSTOM_PATTERN = 'USER_DIRECTORY_ADMIN.DEFINE_CUSTOM_PATTERN',
    /**
     * @value Allow user to close the help message
     */
    DELETABLE_BY_USER = 'USER_DIRECTORY_ADMIN.DELETABLE_BY_USER',
    /**
     * @value The help message can be closed by the user. The user's preference will be saved.
     */
    DELETABLE_BY_USER_DESCRIPTION = 'USER_DIRECTORY_ADMIN.DELETABLE_BY_USER_DESCRIPTION',
    /**
     * @value Deleting the field %NAME% is irreversible. You will delete the entire configuration.
     */
    DELETE_FIELD_DESCRIPTION = 'USER_DIRECTORY_ADMIN.DELETE_FIELD_DESCRIPTION',
    /**
     * @value Delete user directory?
     */
    DELETE_USER_DIRECTORY = 'USER_DIRECTORY_ADMIN.DELETE_USER_DIRECTORY',
    /**
     * @value Deleting the user directory %NAME% is irreversible. You will delete the entire configuration.
     */
    DELETE_USER_DIRECTORY_DESCRIPTION = 'USER_DIRECTORY_ADMIN.DELETE_USER_DIRECTORY_DESCRIPTION',
    /**
     * @value Directory pattern
     */
    DIRECTORY_PATTERN = 'USER_DIRECTORY_ADMIN.DIRECTORY_PATTERN',
    /**
     * @value Display search filters by default
     */
    DISPLAY_FILTERS = 'ADMIN_MODULE_SETTINGS_SHOW_FILTERS',
    /**
     * @value Show organization chart
     */
    DISPLAY_ORGANIZATION_CHART = 'USER_DIRECTORY_ADMIN.DISPLAY_ORGANIZATION_CHART',
    /**
     * @value The organization chart is not limited to groups selected in ”Show users from”.
     */
    DISPLAY_ORGANIZATION_CHART_DESCRIPTION = 'USER_DIRECTORY_ADMIN.DISPLAY_ORGANIZATION_CHART_DESCRIPTION',
    /**
     * @value Display organization chart in the user profile.
     */
    DISPLAY_ORGANIZATION_CHART_NAME_DESCRIPTION = 'USER_DIRECTORY_ADMIN.DISPLAY_ORGANIZATION_CHART_NAME_DESCRIPTION',
    /**
     * @value Display a text area
     * @description Checkbox label in template field form shown when the Text component type is selected
     */
    DISPLAY_TEXT_AREA = 'USER_DIRECTORY_ADMIN.DISPLAY_TEXT_AREA',
    /**
     * @value Display the connected user profile by default
     */
    DISPLAY_USER_PROFILE = 'ADMIN_MODULE_SETTINGS_USER_SHOW_PROFILE',
    /**
     * @value Edit user directory
     */
    EDIT_USER_DIRECTORY = 'USER_DIRECTORY_ADMIN.EDIT_USER_DIRECTORY',
    /**
     * @value Editable by other users
     */
    EDITABLE_BY_OTHER_USERS = 'USER_DIRECTORY_ADMIN.EDITABLE_BY_OTHER_USERS',
    /**
     * @value Allow groups to edit this field for any user.
     */
    EDITABLE_BY_OTHER_USERS_HELPER = 'USER_DIRECTORY_ADMIN.EDITABLE_BY_OTHER_USERS_HELPER',
    /**
     * @value Editable by the user
     */
    EDITABLE_BY_USER = 'USER_DIRECTORY_ADMIN.EDITABLE_BY_USER',
    /**
     * @value Allow user to edit this field in their user profile.
     */
    EDITABLE_BY_USER_HELPER = 'USER_DIRECTORY_ADMIN.EDITABLE_BY_USER_HELPER',
    /**
     * @value Email pattern
     * @description Radio button label for the preset email validation pattern option
     */
    EMAIL_PATTERN = 'USER_DIRECTORY_ADMIN.EMAIL_PATTERN',
    /**
     * @value Regex used for the email pattern: %THE_REGEX%
     * @description Content of the information toggle tip next to the "Email pattern" validation option in the User Directory admin field form. %THE_REGEX% is replaced by the email validation regular expression, which is no longer displayed inline.
     */
    EMAIL_PATTERN_REGEX_INFO = 'USER_DIRECTORY_ADMIN.EMAIL_PATTERN_REGEX_INFO',
    /**
     * @value Error message
     */
    ERROR_MESSAGE = 'USER_DIRECTORY_ADMIN.ERROR_MESSAGE',
    /**
     * @value Define the message displayed to the user if the validation pattern is wrong.
     * @description Helper text below the error message field in the template field form
     */
    ERROR_MESSAGE_HELPER = 'USER_DIRECTORY_ADMIN.ERROR_MESSAGE_HELPER',
    /**
     * @value Field
     * @description Field attribute of a filter
     */
    FIELD = 'ADMIN.SEARCH_SETTINGS.FIELD',
    /**
     * @value Is a directory field
     */
    IS_DIRECTORY_FIELD = 'USER_DIRECTORY_ADMIN.IS_DIRECTORY_FIELD',
    /**
     * @value MAIN
     */
    MAIN_BADGE = 'USER_DIRECTORY_ADMIN.MAIN_BADGE',
    /**
     * @value Name and URL must both be filled in for this language
     * @description Validation error shown in the user directory field editor when only the Name or the URL is filled in for a language, but not both
     */
    NAME_URL_REQUIRED_TOGETHER = 'USER_DIRECTORY_ADMIN.NAME_URL_REQUIRED_TOGETHER',
    /**
     * @value Name and URL must both be filled in for another language
     * @description Validation error shown on the User Directory admin form's Name/URL fields when a mismatch (one filled, one empty) exists in a language other than the one currently displayed, prompting the user to fix it in that other language tab.
     */
    NAME_URL_REQUIRED_TOGETHER_OTHER_LANGUAGE = 'USER_DIRECTORY_ADMIN.NAME_URL_REQUIRED_TOGETHER_OTHER_LANGUAGE',
    /**
     * @value New user field
     */
    NEW_FIELD = 'USER_DIRECTORY_ADMIN.NEW_FIELD',
    /**
     * @value New user directory
     */
    NEW_USER_DIRECTORY = 'USER_DIRECTORY_ADMIN.NEW_USER_DIRECTORY',
    /**
     * @value No user field yet
     * @description Empty state title shown in the template section when no user fields have been added yet
     */
    NO_FIELD_YET = 'USER_DIRECTORY_ADMIN.NO_FIELD_YET',
    /**
     * @value This section lists all user fields displayed in the user directory.
     * @description Empty state description shown in the template section when no user fields have been added yet
     */
    NO_FIELD_YET_DESCRIPTION = 'USER_DIRECTORY_ADMIN.NO_FIELD_YET_DESCRIPTION',
    /**
     * @value This page gives you access to all user directory created.
     * @description Description of the empty state shown on the User directories list page when no user directory has been created yet.
     */
    NO_USER_DIRECTORY_DESCRIPTION = 'USER_DIRECTORY_ADMIN.NO_USER_DIRECTORY_DESCRIPTION',
    /**
     * @value No user directory yet
     * @description Title of the empty state shown on the User directories list page when no user directory has been created yet.
     */
    NO_USER_DIRECTORY_TITLE = 'USER_DIRECTORY_ADMIN.NO_USER_DIRECTORY_TITLE',
    /**
     * @value Set as main user directory
     */
    SET_AS_MAIN_USER_DIRECTORY = 'USER_DIRECTORY_ADMIN.SET_AS_MAIN_USER_DIRECTORY',
    /**
     * @value This user directory will be the default one for the entire site.
     */
    SET_AS_MAIN_USER_DIRECTORY_DESCRIPTION = 'USER_DIRECTORY_ADMIN.SET_AS_MAIN_USER_DIRECTORY_DESCRIPTION',
    /**
     * @value Show in full width
     */
    SHOW_IN_FULL_WIDTH = 'USER_DIRECTORY_ADMIN.SHOW_IN_FULL_WIDTH',
    /**
     * @value The field appear across the full width of the user profile.
     */
    SHOW_IN_FULL_WIDTH_HELPER = 'USER_DIRECTORY_ADMIN.SHOW_IN_FULL_WIDTH_HELPER',
    /**
     * @value Show users from
     */
    SHOW_USERS_FROM = 'USER_DIRECTORY_ADMIN.SHOW_USERS_FROM',
    /**
     * @value Shown in the user directory
     */
    SHOWN_IN_USER_DIRECTORY = 'USER_DIRECTORY_ADMIN.SHOWN_IN_USER_DIRECTORY',
    /**
     * @value Shown users
     */
    SHOWN_USERS = 'USER_DIRECTORY_ADMIN.SHOWN_USERS',
    /**
     * @value Only users from the groups selected will appear in the user directory.
     */
    SHOWN_USERS_DESCRIPTION = 'USER_DIRECTORY_ADMIN.SHOWN_USERS_DESCRIPTION',
    /**
     * @value Configure which user profile fields are visible on the user directory and how they are populated.
     */
    TEMPLATE_DESCRIPTION = 'USER_DIRECTORY_ADMIN.TEMPLATE_DESCRIPTION',
    /**
     * @value The platform suggests a default template. Customize this template by renaming, deleting and adding fields.
     */
    TEMPLATE_INFO_PANEL = 'USER_DIRECTORY_ADMIN.TEMPLATE_INFO_PANEL',
    /**
     * @value User directories
     */
    TITLE_NAV = 'USER_DIRECTORY_PLURAL',
    /**
     * @value Usable to filter users
     */
    USABLE_TO_FILTER_USERS = 'USER_DIRECTORY_ADMIN.USABLE_TO_FILTER_USERS',
    /**
     * @value Validation pattern
     */
    VALIDATION_PATTERN = 'USER_DIRECTORY_ADMIN.VALIDATION_PATTERN',
    /**
     * @value Global and site administrators can see this field, even if they are not part of the selected groups.
     */
    VISIBLE_BY_HELPER = 'USER_DIRECTORY_ADMIN.VISIBLE_BY_HELPER',
    /**
     * @value Work
     */
    WORK = 'USER_DIRECTORY_PHONE_WORK',
}
